import { BrowserRouter, Route, Routes as Switches } from "react-router-dom";
import LogoutPage from "./components/LogoutPage";
import Fruits from "./pages/Activities/Fruits";
import StatsPage from "./pages/Admin/StatsPage";
import AgoraNewVideoCall from "./pages/AgoraVideoCall/AgoraNewVideoCall";
import AppointmentHistory from "./pages/AppointmentHistory";
import AvailabilitySettings from "./pages/AvailabilitySettings";
import ContactUsPage from "./pages/ContactUsPage";
import DashboardRoot from "./pages/Dashboard/DashboardRoot";
import AssessmentReportUpload from "./pages/DoctorsPages/AssessmentReportUpload";
import Authentication from "./pages/DoctorsPages/Authentication";
import DashboardDoctor from "./pages/DoctorsPages/DashboardDoctor";
import SessionDetails from "./pages/DoctorsPages/SessionDetails";
import TherapistContactPage from "./pages/DoctorsPages/TherapistContactPage";
import OneVideoCall from "./pages/OneVideoCall";
import OurApproach from "./pages/OurApproach";
import ForgotPassword from "./pages/Password/ForgotPassword";
import ResetPassword from "./pages/Password/ResetPassword";
import PaymentFailed from "./pages/Payment/PaymentFailed";
import PaymentSuccess from "./pages/Payment/PaymentSuccess";
import PricingPage from "./pages/PricingPage";
import Signup from "./pages/Signup";
import Sitemap from "./pages/Sitemap";
import VideoCall from "./pages/VideoCall";
import AdminVideoCall from "./pages/AgoraVideoCall/AdminVideoCall";
import Survey from "./pages/Survey";
import FreeAssessment from "./pages/Survey/FreeAssessment";
import ChildSurvey from "./pages/Survey/childSurvey";
import SurveyChart from "./pages/Survey/surveyChart";
import AdvancedAssessmentChart from "./pages/Survey/advancedAssessmentChart";
import { AssessmentDashboard } from "./pages/Survey/assessmentDashboard";
import Verification from "./pages/Survey/verification";
import { ViewReport } from "./pages/Survey/viewReport";
// import Call from "./calls/Call";

const Routes = () => {

  return (
    <BrowserRouter>
      <Switches>
        <Route path="/sitemap" element={<Sitemap />} />
        <Route path="/signup" element={<Signup />} />

        <Route path="/" element={<Signup />} />

        <Route path="/dashboard/*" element={<DashboardRoot />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/ourapproach" element={<OurApproach />} />
        <Route path="/register" element={<Signup />} />
        <Route path="/contactus" element={<ContactUsPage />} />
        <Route
          path="/availability"
          element={<AvailabilitySettings doctorID={""} />}
        />
        <Route path="/doctor/dashboard" element={<DashboardDoctor />} />
        <Route path="/join-class" element={<VideoCall />} />
        <Route path="/admin" element={<StatsPage />} />
        <Route path="/call" element={<OneVideoCall />} />
        <Route path="/therapist/contactus" element={<TherapistContactPage />} />
        <Route path="/logout" element={<LogoutPage />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-failed" element={<PaymentFailed />} />

        <Route path="/therapist/signin/" element={<Authentication />} />

        <Route path="/reset-password/" element={<ResetPassword />} />
        <Route
          path="/forgot-password/"
          element={<ForgotPassword onBack={() => {}} />}
        />
        <Route path="/appointment-history" element={<AppointmentHistory />} />
        <Route
          path="/appointments"
          element={<SessionDetails sessionId={5} />}
        />
        <Route path="/fruits" element={<Fruits />} />
        <Route path="/videocall" element={<AgoraNewVideoCall />} />
        <Route path="/videocalladmin" element={<AdminVideoCall />} />
        <Route
          path="/doctors/:doctorID/appointment/:appointmentID"
          element={<AssessmentReportUpload doctorID={""} />}
        />
        <Route path="/survey" element={<Survey />} />
        <Route path="/free-assessment" element={<FreeAssessment />} />
        <Route path="/advancedsurvey" element={<ChildSurvey />} />
        <Route path="/assessmentreport" element={<SurveyChart />} />
        <Route path="/advanceassessmentreport" element={<AdvancedAssessmentChart />} />
        <Route path="/assessmentdashboard" element={<AssessmentDashboard />} />
        <Route path="/viewreport" element={<ViewReport />} />
        <Route path="/verify" element={<Verification />} />
      </Switches>
    </BrowserRouter>
  );
};

export default Routes;
